import { takeLatest, put, call, select } from 'redux-saga/effects';
import { SEND_BOOKING_NOTIFICATION_SAGA } from "../sagaTypes";
import { loaderAction, bookingNotificationFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { BOOKING_NOTIFICATION_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/send_booking_notification`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerSendBookingNotification(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('booking_id', args.data.booking_id);
        formData.append('title', args.data.title);
        formData.append('message', args.data.message);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем форму рассылки сообщений
            yield put(bookingNotificationFormAction(BOOKING_NOTIFICATION_FORM_INITIAL));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherSendBookingNotification() {
    yield takeLatest(SEND_BOOKING_NOTIFICATION_SAGA, workerSendBookingNotification);
}